
import { TYPE, canOnlyGo } from "./network/network_api"
import {Button} from "./button";
import Stream from "./frp/stream";
import { Image, canFullscreen, canScreenLock } from "utils";
import SETTINGS from "settings";
import { SCREEN_RATIO_1, SCREEN_RATIO_2 } from 'boot'
import helpConfig from 'cfg/help-config';
import { FINISHING_STATES } from "./slot";
import { literal_price, progressive_jackpot_panel, desc_to_stream, makeFrame, makeButton } from 'ui_commons'

export default function( { uiConfig, parent, always_interactive_container, spec, uiContainer, upperScenesContainer } )
{
    const space = parent.child( "ui" );

    //all user input in current approach must be ignored by all subsequent receivers when consumed once:
    const $keyboard = parent.s( "keyboard" )
        .with( parent.s( "is_progressive_jackpot" ), ( event, pj ) => ({ event, pj }) )
        .filter( ({ pj }) => ! pj )
        .map( ({ event }) => ({ event, consumed : false }) )
    const $barrelClick = space.s( "barrelClick" ).map( () => ({ consumed : true }) );
    $barrelClick
        .withLatestFrom(space.s( "isFreegames" ), space.s( "canInterruptBarrel" ), (click, free, can) => free && can)
        .filter(interrupt => interrupt)
        .map(() => {})
        .to(space.s('stop'));

    const $isRoulette = space.s( "isRoulette" );
    const $notRoulette = $isRoulette.map( r => ! r );

    const $notRisk = space.s( "isRisk" ).map( i => ! i );
    const $notFreegames = space.s( "isFreegames" ).map( f => ! f );
    const $isHelp = space.s( "isHelp" );
    const $notHelp = $isHelp.map( h => ! h );
    const $helpNotPaging = space.s( "helpPaging" ).map( p => ! p );
    const $notJackpot = space.s( "isJackpot" ).map( j => ! j );
    const $notBonus = space.s( "isBonus" ).map( b => ! b );
    const $notProgJP = space.s('isProgressiveJP').map(is => !is);
    const $not_error = parent.s( "isError" ).map( ie => ! ie )

    const $entering_bonus = parent.s( 'state' )
        .any( parent.s( 'pending' ), ( state, pending ) => (canOnlyGo( TYPE.FREESPIN, state ) || canOnlyGo( TYPE.BONUS_1, state )) && pending )
    const $not_entering_bonus = $entering_bonus.map( ef => ! ef )

    parent.s('change_screen').map(screen => {
        if (screen.w > screen.h) {
            return false
        }
        else {
            return true
        }
    })
        .to(space.s('changeToVertical'));

    const $gambleVisible = Stream.any(
        space.s( "riskInvitation" ),
        $notHelp,
        $notBonus
    )
    .map( merge => _.every( merge ) && spec.risks.length > 0 )

    const $canSpin = space.s( "enabled" )
        .combineLatest( space.s( "canBet" ), space.s( "canPay" ), $notFreegames )
        .map( merge => _.every( merge ) );

    const container = new PIXI.Container();
    $isRoulette
        .any($isHelp, (r, h) => !r || h).subscribe( v => container.visible = v );

    const needSettingsPanel = !!uiConfig.panels && !!uiConfig.panels.settings;
    const needMenuPanel = !!uiConfig.panels && !!uiConfig.panels.menu;

    let settingsPanel = null;
    if (needSettingsPanel) {
        settingsPanel = new PIXI.Sprite(PIXI.utils.TextureCache[uiConfig.panels.settings.frame]);
        settingsPanel.interactive = true;
    }

    let menuPanel = null;
    if (needMenuPanel) {
        menuPanel = new PIXI.Sprite(PIXI.utils.TextureCache[uiConfig.panels.menu.frame]);
        menuPanel.scale.set(SETTINGS.screen.resolution.width / 1024, SETTINGS.screen.resolution.height / 768);
        menuPanel.interactive = true;
    }

    const $openMenu = space.s("openMenu", false);

    const needProgJP = !!uiConfig.progressive_jackpot_panel;

    if (needProgJP) {
        progressive_jackpot_panel(
            parent,
            (needMenuPanel) ? menuPanel : container,
            uiConfig.progressive_jackpot_panel,
            $openMenu
        )
    }
    

    const getParentContainer = (config) => {
        if (!config.location) {
            return container;
        }
        else {
            switch (config.location) {
                case "settings":
                    return settingsPanel;
                case "menu":
                    return menuPanel;
                default:
                    return container;
            }
        }
    };



    /* _    ____ ___  ____ _    ____
       |    |__| |__] |___ |    [__
       |___ |  | |__] |___ |___ ___]
    */

    let { frames } = uiConfig;
    const createdLabels = []
    function l( desc, to, v, overriddenContainer, $text_v )
    {
        if (!frames[ desc ]) return;

        createdLabels.push( desc )
        const spec = frames[ desc ]
        const label = makeFrame( spec, uiConfig.common.font );

        ( overriddenContainer || getParentContainer(spec) ).addChild( label.frame );
        if ( to ) to.subscribe( p => {
            if( p === undefined ) p = "";
            label.label.text = p;
        } );
        
        if ( $text_v ) $text_v.on( text_v => label.label.visible = text_v )

        let $v;
        if ( v ) $v = v.length ? Stream.combineLatest( ... v ).map( merge => _.every( merge ) ) : v;
        if ( $v ) $v
            .name( space, "label_" + desc )
            .on( visible => label.frame.visible = visible );
    }

    const $winLabelValue = space.s( "win" )
        .any(parent.s('risk:result_win'), (usual, risk) => ({usual, risk}))
        .withLatestFrom(space.s('isRisk'), (win, isRisk) => {
            if (isRisk) {
                return win.risk;
            }
            else {
                return win.usual;
            }
        });

    l( 'lines',     space.s( "linesValue" ),      [ $notRisk, $notHelp, $notJackpot, $notBonus ] );
    l( 'line_bet',  space.s( "multiplierValue" ), [ $notRisk, $notHelp, $notJackpot, $notBonus ] );
    l( 'win',       $winLabelValue,               [           $notHelp, $notJackpot, $notBonus ], undefined, $winLabelValue.with( $not_error, ( v, ne ) => v > 0 && $not_error ) )
    l( 'credits',   space.s( "credits" ),         [           $notHelp, $notJackpot, $notBonus ], undefined, $not_error );
    l( 'total_bet', space.s( "price" ),           [           $notHelp, $notJackpot, $notBonus ] );

    //creating any other labels present in configuration:
    for ( const desc in frames )
    {
        if ( createdLabels.indexOf( desc ) >= 0 ) continue
        const spec = frames[ desc ]
        l(
            desc,
            spec.$value ? parent.s( spec.$value ) : undefined,
            spec.$visible ? parent.s( spec.$visible ) : undefined,
        )
    }

    /* ___  _  _ ___ ___ ____ _  _ ____
       |__] |  |  |   |  |  | |\ | [__
       |__] |__|  |   |  |__| | \| ___]
    */


    let { buttons } = uiConfig;
    const createdButtons = []
    /**
     * @param e stream or array of streams if button is ENABLED. Keyboard events of keys will be filtered out when button is NOT enabled.
     * @param v stream or array of streams if button is VISIBLE. Keyboard events of keys will be filtered out when button is NOT visible.
     * @param equiv What additional input may be interpreted the same as button click (when button can be clicked). Must be a stream of objects with "consumed" property originally equalling false.
     */
    function b(
        desc,
        to,
        keys,
        { e, v, equiv } = {},
        overriddenContainer,
        active = true
    )
    {
        if (!buttons[ desc ]) return;

        const positionOnDevice = buttons[ desc ].position;

        createdButtons.push( desc )
        const button = makeButton( buttons[ desc ], positionOnDevice );

        const verticalButton = buttons[ desc ].verticalButton ? makeButton( Object.assign(desc, buttons[ desc ], buttons[ desc ].verticalButton ) ) : undefined;

        ( overriddenContainer || getParentContainer(buttons[desc]) ).addChild( button );
        if (verticalButton) {
            ( overriddenContainer || getParentContainer(buttons[desc]) ).addChild( verticalButton );
        }

        const $e = desc_to_stream( space, e, "button_" + desc + "_enabled" )
        if (active) {
            $e.on(enabled => {
                button.enabled = enabled;
                if (verticalButton) verticalButton.enabled = enabled;
            });
        }
        else {
            button.interactive = false;
            if (verticalButton) verticalButton.interactive = false;
        }

        const $v = desc_to_stream( space, v, "button_" + desc + "_visible" )
        $v.on( visible => button.visible = visible )
        $v
            .any(space.s('changeToVertical'), (v, vert) => ({v, vert}))
            .on( ({v, vert}) => {
                if (verticalButton) {
                    button.visible = !vert && v;
                    verticalButton.visible = vert && v;
                }
                else {
                    button.visible = v;
                }
            } );

        const $click = space.s( "button_" + desc + "_click" )
        button.callback = () => $click.next();
        if (verticalButton) verticalButton.callback = () => $click.next();
        if ( desc != "autoplay" && desc != "stop" && desc != 'collect' ) $click.to( space.s( "autoplayOff" ) );
        if ( keys || equiv )
        {
            let $input = $keyboard.filter( ({ event }) => _.includes( keys || [], event ) );
            $input.name( space, "button_" + desc + "_equiv" )
            if ( equiv ) equiv.to( $input );

            if ( $e ) $input = $input.with( $e, ( state, e ) => ({ state, e }) ).filter( ({ e }) => e ).map( ({ state }) => state );
            if ( $v ) $input = $input.with( $v, ( state, v ) => ({ state, v }) ).filter( ({ v }) => v ).map( ({ state }) => state );

            //all user input in current approach must be ignored by all subsequent receivers when consumed once:
            $input
                .filter( state => ! state || ! state.consumed )
                .map( state => { if ( state ) state.consumed = true; return undefined; } )
                .to( $click )
        }
        if ( to ) $click.to( to )

        space.s( 'need_fullscreen')
            .any(space.s('changeToVertical'), (full, vert) => ({full, vert}))
            .on(({full, vert}) => {
                if (vert && buttons[ desc ].position_vertical) {
                    button.position = buttons[ desc ].position_vertical;
                }
                else {
                    button.position = positionOnDevice
                }
            })

        return button;
    }

    // KEY CODES:
    const ENTER = 13;
    const ESC   = 27;
    const SPACE = 32;
    const KEY_1 = 49;
    const F1    = 112;
    const F2    = 113;
    const F3    = 114;
    const F4    = 115;
    const F5    = 116;
    const F6    = 117;
    const F7    = 118;
    const F8    = 119;
    const F9    = 120;
    const F10   = 121;

    b( "spin",             space.s( "spin" ),               [ ENTER, SPACE, F8 ], {
        e : $canSpin,
        v : [
            space.s( "spinVisible" ),
            $notRisk,
            $notHelp,
            $notBonus,
            $openMenu.map(o => !o),
            $not_entering_bonus,
        ],
        equiv : $barrelClick
    },
        uiContainer);

    b( "collect",          space.s( "collect" ),            [ ENTER, SPACE, F8 ], {
        e : space.s( "collectEnabled" ),
        v : space.s( "collectVisible" ).any(
            space.s( "finishVisible" ).map( f => ! f ),
            $notHelp,
            $openMenu.map(o => !o),
            space.s('isRisk'),
            parent.s('risk:result_win'),
            $notProgJP,
            $not_entering_bonus,
            ( v, nfv, nh, nom, r, w, pjp, nef ) =>
                ( ( v && nfv && nh && nom && pjp && !r ) || ( v && nfv && nh && nom && pjp && r && w !== 0 ) ) && nef )
            ,
        equiv : $barrelClick
    },
        uiContainer);

    b( "stop",             space.s( "stop" ),               [ ENTER, SPACE, F8 ], {
        e : space.s( "canInterruptBarrel" ),
        v : [
            space.s( "mayStop" ),
            $notHelp,
            $notBonus,
            $notFreegames,
            $openMenu.map(o => !o),
            $not_entering_bonus,
        ],
        equiv : $barrelClick
    },
        uiContainer);
    b( "start",            space.s( "start" ),              [ ENTER, SPACE, F8 ], {
        e : [
            space.s( "displayingWin" ).map( d => ! d ),
            space.s( "beginningFeature" ).map( b => ! b )
        ],
        v : [
            space.s( "displayingWin" ).map( d => ! d ),
            space.s( "beginningFeature" ).map( b => ! b ),
            space.s( "canStartFeature" ),
            $notHelp,
            $notBonus,
            $not_entering_bonus,
        ],
        equiv : $barrelClick
    } );
    b( "finish",           space.s( "finish" ),             [ ENTER, SPACE, F8 ], {
        e : [
            space.s( "enabled" ),
            space.s( "finishEnabled" ),
        ],
        v : [
            space.s( "finishEnabled" ),
            //space.s( "finishVisible" ),
            $notHelp,
        ],
        equiv : $barrelClick
    } );

    b( "info",             space.s( "info" ),               [ KEY_1, F1 ],        {
        e : $openMenu,
        v : $openMenu
    } );

    const $muteSound = parent.s("muteSound").desc( 'mute sound by player' );

    b( "sound_on",             space.s( "sound_on" ),               [ ],        {
        e : [
            $openMenu,
            $muteSound
        ],
        v : [
            $openMenu,
            $muteSound
        ]
    } );
    b( "sound_off",             space.s( "sound_off" ),               [ ],        {
        e : [
            $openMenu,
            $muteSound.map(m => !m)
        ],
        v : [
            $openMenu,
            $muteSound.map(m => !m)
        ]
    } );
    space.s("sound_on").map(() => false).to($muteSound);
    space.s("sound_off").map(() => true).to($muteSound);
    $muteSound
        .any( parent.s( 'tab_visibility' ), ( mute, tv ) => ({ mute, tv }) )
        .on( ({ mute, tv }) => {
            mute = mute || ( ! tv )
            Howler.mute( mute )
            if ( ! mute ) Howler.volume( SETTINGS.volume )
        } )

    space.s( 'landscape_off' ).map( () => false ).to( space.s( 'landscape' ) )
    b( "vertical",               space.s( 'landscape_off' ),          [ ],        {
        e : space.s( 'landscape' ),
        v : $openMenu
    } );
    
    space.s( 'landscape_on' ).map( () => true ).to( space.s( 'landscape' ) )
    b( "horizontal",             space.s( 'landscape_on' ),           [ ],        {
        e : space.s( 'landscape' ).map( l => ! l ),
        v : $openMenu
    },
        null,
        canScreenLock());

    space.s( 'screen_ratio_1' ).map( () => SCREEN_RATIO_1 ).to( parent.s( 'screen_ratio' ) )
    b( "wide",                   space.s( 'screen_ratio_1' ),     [ ],        {
        e : parent.s( 'screen_ratio' ).map( r => r != SCREEN_RATIO_1 ),
        v : $openMenu
    } );

    space.s( 'screen_ratio_2' ).map( () => SCREEN_RATIO_2 ).to( parent.s( 'screen_ratio' ) )
    b( "narrow",             space.s( 'screen_ratio_2' ),        [ ],        {
        e : parent.s( 'screen_ratio' ).map( r => r != SCREEN_RATIO_2 ),
        v : $openMenu
    } );

    b( "close_menu",             space.s( "close_menu" ),               [ ],        {
        e : $openMenu,
        v : $openMenu
    } );

    b( "userMenu",             space.s( "userMenu" ),           [],              {
            e : [
                $openMenu.map(open => !open),
                $notFreegames,
                $notBonus,
                $not_entering_bonus
                ],
            v : [
                $openMenu.map(open => !open),
                $notHelp,
                $notBonus,
                $notFreegames,
                $notProgJP,
                $notRoulette,
                $notJackpot
            ]
        },
        uiContainer
    );

    if (buttons['bonus_sound_on'] && buttons['bonus_sound_off']) {
        b( "bonus_sound_on",             space.s( "sound_on" ),               [ ],        {
            e : $muteSound.any(
                space.s('isBonus'),
                space.s('isFreegames'),
                (mute, b, f) => mute && (b || f)
            )
            ,
            v : $muteSound.any(
                space.s('isBonus'),
                space.s('isFreegames'),
                (mute, b, f) => mute && (b || f)
            )
        },
            uiContainer);
        b( "bonus_sound_off",             space.s( "sound_off" ),               [ ],        {
            e : $muteSound.map(m => !m).any(
                space.s('isBonus'),
                space.s('isFreegames'),
                (mute, b, f) => mute && (b || f)
            )
            ,
            v : $muteSound.map(m => !m).any(
                space.s('isBonus'),
                space.s('isFreegames'),
                (mute, b, f) => mute && (b || f)
            )
        },
            uiContainer);
    }

    b( "gamble",           space.s( "gamble" ),             [ F7 ],               {
        e : [
            space.s( "enabled" ),
            space.s( "finishVisible" ).map( v => ! v ),
            parent.s( 'state' ).map( s => s.state.risk_possible ),
        ],
        v : [
            $gambleVisible,
            space.s( "finishVisible" ).map(v => !v),
            $openMenu.map(o => !o)
        ]
    },
        uiContainer);
    b( "autoplay",         space.s( "autoplayOn" ),         [ F9 ],               {
        e : [
            $gambleVisible.map( gv => ! gv ),
            $notFreegames
        ],
        v : [
            $gambleVisible.map( gv => ! gv ),
            $notRisk,
            $notHelp,
            $notBonus,
            $notJackpot,
            $notRoulette,
            space.s( "isAutoplay" ).map( a => ! a ),
            space.s( "canStartFeature" ).map(c => !c),
            space.s( "finishVisible" ).map(v => !v),
            $notFreegames,
            $openMenu.map(o => !o),
            $notProgJP,
            $not_entering_bonus,
        ]
    },
        uiContainer);
    b( "autoplayoff",      space.s( "autoplayOff" ),        [ F9 ],              {
        //should always be able to cancel autoplay:
        //e : space.s( "enabled" ),
        v : [
            space.s( "isAutoplay" ),
            $gambleVisible.map( g => ! g ),
            $notHelp,
            $notJackpot,
            $notBonus,
            $openMenu.map(o => !o),
            $notProgJP,
        ]
    },
        uiContainer);
    b( "menu",             parent.s( "goLobby" ),           [ ESC ],              {
        e : space.s( "enabled" )
                .combineLatest(
                    space.s( "canBet" ),
                    parent.s( "isError" ),
                    ( e, c, i ) => ( e && c ) || i
                ),
        v : SETTINGS.nolobby ? false : $notHelp.any(
                $notJackpot,
                $notBonus,
                parent.s( "isError" ),
                $notRoulette,
                $openMenu,
                $notRisk,
                $notFreegames,
                $openMenu,
                $notProgJP,
                $not_entering_bonus,
                space.s('finishing').map(f => f != FINISHING_STATES.SHOWING_TABLE && f != FINISHING_STATES.FINISH_INVITATION),
                ( nh, nj, nb, e, nr, om, nri, nf, op, pjp, nef, fin ) => ( ( nh && nj && nb && nr && !om && nri && nf && !op && pjp && fin) && nef ) || e
            )
    },
        always_interactive_container
    );


    b( "betmax",           space.s( "maxBet" ),             undefined,            {
        e : [
            space.s( "enabled" ),
            space.s( "canBet" ),
            space.s( "canMaxBet" ),
        ],
        v : [
            space.s( "canMaxBet" ).combineLatest( space.s( "canMinBet" ), ( max, min ) => max || ! min ),
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "betmin",           space.s( "minBet" ),             undefined,            {
        e : [
            space.s( "enabled" ),
            space.s( "canBet" ),
        ],
        v : [
            space.s( "canMinBet" ),
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "decrease_lines",   space.s( "decreaseLines" ),      undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeLines" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "increase_lines",   space.s( "increaseLines" ),      undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeLines" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "decrease_linebet", space.s( "decreaseMultiplier" ), undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeMultiplier" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "increase_linebet", space.s( "increaseMultiplier" ), undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeMultiplier" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );

    const $openSettings = space.s("openSettings", false);

    b( "settings_open",             space.s( "settings_open" ),           [],              {
            e : space.s( "enabled" )
                .combineLatest(
                    space.s( "canBet" ),
                    $openSettings,
                    ( e, c, o ) => ( e && c && !o )
                ),
            v : [
                $notJackpot,
                $notBonus,
                $notRoulette,
                $openSettings.map(o => !o),
                $not_entering_bonus,
            ]
        }
    );

    b( "settings_close",             space.s( "settings_close" ),           [],              {
            e : space.s( "enabled" )
                .combineLatest(
                    space.s( "canBet" ),
                    $openSettings,
                    ( e, c, o ) => ( e && c && o )
                ),
            v : [
                $notJackpot,
                $notBonus,
                $notRoulette,
                $openSettings,
                $not_entering_bonus,
            ]
        }
    );

    b( "bet_open",             space.s( "settings_open" ),           [],              {
            e : space.s( "enabled" )
                .combineLatest(
                    space.s( "canBet" ),
                    space.s('changeToVertical'),
                    ( e, c, v ) => ( e && c && v )
                ),
            v : [
                $notHelp,
                $notJackpot,
                $notBonus,
                $notRoulette,
                $notFreegames,
                $notRisk,
                $openMenu.map(om => !om),
                space.s('changeToVertical'),
                $openSettings.map(os => !os),
                $notProgJP,
                space.s( "beginningFeature" ).map( b => ! b ),
                space.s( "canStartFeature" ).map(sf => !sf),
                space.s('finishing').map(f => f != FINISHING_STATES.SHOWING_TABLE && f != FINISHING_STATES.FINISH_INVITATION),
                $not_entering_bonus,
            ]
        },
        uiContainer
    );

    b( "bet_close",             space.s( "settings_close" ),           [],              {
            e : space.s( "enabled" )
                .combineLatest(
                    space.s( "canBet" ),
                    space.s('changeToVertical'),
                    ( e, c, v ) => ( e && c && v )
                ),
            v : [
                $notHelp,
                $notJackpot,
                $notBonus,
                $notRoulette,
                $notFreegames,
                $notRisk,
                $openMenu.map(om => !om),
                space.s('changeToVertical'),
                $openSettings,
                $notProgJP,
                space.s( "beginningFeature" ).map( b => ! b ),
                space.s( "canStartFeature" ).map(sf => !sf),
                space.s('finishing').map(f => f != FINISHING_STATES.SHOWING_TABLE && f != FINISHING_STATES.FINISH_INVITATION),
                $not_entering_bonus,
            ]
        },
        uiContainer
    );

    //inside help(info) scene:
    b( "next",             space.s( "helpNext" ),           [ F4 ],               {
        e : [
            space.s( "helpCanNext" ),
            $helpNotPaging,
        ],
        v : $isHelp.map(h => h && (helpConfig.help.pages > 1)),
    } );
    b( "back",             space.s( "helpPrevious" ),       [ F2 ],               {
        e : [
            space.s( "helpCanPrevious" ),
            $helpNotPaging,
        ],
        v : $isHelp.map(h => h && (helpConfig.help.pages > 1)),
    } );
    b( "exit",             space.s( "helpExit" ),           [ F3 ],               {
        e : $helpNotPaging,
        v : $isHelp,
    } );

    space.s("helpExit").map(() => true).to($openMenu);

    //creating any other buttons present in configuration:
    for ( const desc in buttons )
    {
        if ( createdButtons.indexOf( desc ) >= 0 ) continue
        b( desc )
    }

    if (needSettingsPanel) {
        const $visibleVerticalSettings = space.s('changeToVertical').any($openSettings, (v, os) => v && !os)
            .map(v => !v);

        const $visibleSettings = space.s("panel_settings_visible");
        $notHelp.any(
            $notJackpot,
            $notBonus,
            $notRoulette,
            $notFreegames,
            $notRisk,
            $openMenu,
            $visibleVerticalSettings,
            $notProgJP,
            space.s('finishing').map(f => f != FINISHING_STATES.SHOWING_TABLE && f != FINISHING_STATES.FINISH_INVITATION),
            space.s("beginningFeature").map(b => !b),
            space.s("canStartFeature").map(sf => !sf),
            $not_entering_bonus,
            (nh, nj, nb, nr, nf, nri, op, v, pjp, fin, bf, csf, eb) => ( nh && nj && nb && nr && nf && nri && !op && v && pjp && fin && bf && csf && eb )
        ).to($visibleSettings);
        $visibleSettings.on(v => settingsPanel.visible = v);

        const settingsPositions = uiConfig.panels.settings.position;

        settingsPanel.position.set(settingsPositions.close.x, settingsPositions.close.y);
        uiContainer.addChild(settingsPanel);

        const moveSetttingsPanel = (toX, complete) => {
            settingsPanel.visible = true;
            const moveTween = new TWEEN.Tween(settingsPanel)
                .to({x: toX}, 250)
                .onComplete(() => {
                    complete()
                })
                .start();
        };

        space.s("settings_close")
            .any(space.s('spinStart'), $barrelClick)
            .withLatestFrom($openSettings, (click, open) => open)
            .on(open => {
                if (open) {
                    moveSetttingsPanel(settingsPositions.close.x, () => {
                        $openSettings.next(false);
                    })
                }
            });

        space.s("settings_open")
            .withLatestFrom($openSettings, (click, open) => open)
            .on(open => {
                if (!open) {
                    moveSetttingsPanel(settingsPositions.open.x, () => {
                        $openSettings.next(true);
                    })
                }
            });
    }

    if (needMenuPanel) {
        const $visibleMenuPanel = space.s("panel_menu_visible", false);
        $visibleMenuPanel.on(v => menuPanel.visible = v);
        menuPanel.position.set(uiConfig.panels.menu.position.close.x, uiConfig.panels.menu.position.close.y);
        menuPanel.visible = false;
        // этот контейнер дожен быть поверх всех сцен и в разрешении игры
        upperScenesContainer.addChild(menuPanel);//uiContainer.addChild(menuPanel);

        $openMenu.to($visibleMenuPanel);//on(open => menuPanel.visible = open);
    }

    space.s("button_info_click").map(() => false).to($openMenu);
    space.s("button_close_menu_click").map(() => false).to($openMenu);
    space.s("button_userMenu_click").map(() => true).to($openMenu);

    const k = key => $keyboard.filter( ({ event }) => key.length ? _.includes( key, event ) : event == key );

    //set lines by keyboard:
    function setLines( key, lines )
    {
        k( key )
            .withLatestFrom(
                $notHelp,
                space.s( "canBet" ),
                parent.s( "isError" ),
                ( k, notHelp, canBet, isError ) => notHelp && canBet && ! isError
            )
            .filter( can => can )
            .map( () => lines )
            .subscribe( space.s( "setLines" ) );
    }
    switch ( spec.lines_array.length )
    {
        case 1:
            break
        case 5:
            setLines( F2, 0 );
            setLines( F3, 1 );
            setLines( F4, 2 );
            setLines( F5, 3 );
            setLines( F6, 4 );
            break
        default:
            console.error( "Undefined amount of lines groups." )
    }

    const $startImpulse = space.s( "startImpulse" );
    k( [ ENTER, SPACE, F8 ] ).subscribe( $startImpulse );
    $startImpulse
        .withLatestFrom(
            parent.s( "isError" ),
            parent.s( "animating" ),
            ( key, isError, animating ) => ({ isError, animating })
        )
        .filter( ({ isError, animating }) => ! isError && ! animating )
        .map( () => undefined )
        .subscribe( space.s( "startKey" ) );

    if (needProgJP && !uiConfig.no_currency) {
        currency(
            (needMenuPanel) ? menuPanel : container,
            space.s("credits"),
            parent.s("balance"),
            parent.s("balance:money"),
            $openMenu
        );
    }

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    //always_interactive_container должен скейлиться вместе со всем интерфейсом за пределами игры
    uiContainer.addChild(always_interactive_container);

    return {
        space,
        ui : container,
    };
}

function currency( container, $credits, $balance, $money, $visible )
{
    const view = new PIXI.Container;
    container.addChild( view );
    $visible.subscribe( v => view.visible = v );

    const fontSize = 40;

    // left billet
    let currencyFrame = new PIXI.Container;
    currencyFrame.visible = false;
    view.addChild( currencyFrame );

    currencyFrame.position.set( 40, 700 );

    const currencySignLabel = new PIXI.Text(
        '',
        new PIXI.TextStyle(
        {
            fontFamily: 'Arial',
            fontSize: fontSize,
            fontStyle: 'bold',
            fill: ['#000000']
        } )
    );
    currencySignLabel.position.set( 4, 5 );
    currencyFrame.addChild( currencySignLabel );

    const currencyValueLabel = new PIXI.Text(
        '',
        new PIXI.TextStyle(
        {
            fontFamily: 'Arial',
            fontSize: fontSize,
            fontWeight: 'bold',
            fill: ['#000000']
        } )
    );
    currencyValueLabel.position.set( 100, 5 );
    currencyFrame.addChild( currencyValueLabel );


    // right billet
    const creditPriceFrame = new PIXI.Container;
    creditPriceFrame.visible = false;
    view.addChild( creditPriceFrame );
    creditPriceFrame.position.set( 600, 700 )

    const creditPriceLabel = new PIXI.Text(
        '',
        new PIXI.TextStyle(
        {
            fontFamily: 'Arial',
            fontSize: fontSize,
            fontStyle: 'bold',
            fill: ['#000000']
        } )
    );
    creditPriceLabel.position.set( 4, 5 );
    creditPriceFrame.addChild( creditPriceLabel );

    $balance
        .any( $credits, $money, ( balance, credits, money ) => ({ balance, credits, money }) )
        .subscribe( ({ balance, credits, money }) =>
        {
            let visible = true;
            if ( ! balance.currency || ! balance.credit_price ) visible = false;
            else if ( balance.currency.visible === false || balance.currency.visible === "false" ) visible = false;
            currencyFrame.visible = creditPriceFrame.visible = visible;
            if ( ! visible ) return;

            currencySignLabel.text = balance.currency.code_name;

            currencyValueLabel.text = literal_price( money, balance.currency.minor_unit, balance.currency.delimiter )

            creditPriceLabel.text = "1 credit = " + literal_price( balance.credit_price, balance.currency.minor_unit, balance.currency.delimiter ) + " " + balance.currency.code_name
        } );
}



// WEBPACK FOOTER //
// ./src/library/ui_mobile_view.es6